<! -- Left tab defined in tab group. this prevents double tabs -->
<div
    class="border-tab border-l-0 border-solid border-tab_base font-roboto text-tab transition cursor-pointer focus:outline-none"
    [ngClass]="{
        'bg-tab-background-base': !selected,
        'text-tab-text-base': !selected,
        'focus:bg-tab-background-focus': !selected,
        'hover:bg-tab-background-hover': !selected,
        'bg-tab-background-selected text-tab-text-selected border-b-tab_bottom_selected ': selected,
        'min-w-tab_base': !icon && iconPos !== 'noTitle',
        'min-w-tab_text_and_icon': icon && iconPos !== 'noTitle',
        'min-w-tab_icon_only': icon && iconPos === 'noTitle'
    }"
    (click)="clicked.emit(value)"
    tabindex="0"
    #tabElement>
    @if (selected) {
    <div class="relative">
        <div class="bg-tab-background-select_bar w-full h-tab_select_bar absolute transition top-[-1px]"></div>
    </div>
    }
    <div class="flex justify-center items-center h-tab px-sm whitespace-nowrap">
        <span
            porIcon
            *ngIf="icon"
            [icon]="icon"
            class="flex items-center"
            [ngClass]="{
                'order-1': iconPos === 'after',
                'ml-xs': iconPos === 'after',
                'mr-xs': iconPos === 'before'
            }"
            [height]="13"
            [width]="13"></span>
        @if (iconPos !== 'noTitle') {
            {{ title }}
        }
    </div>
</div>

<ng-template #projectedContent>
    <ng-content></ng-content>
</ng-template>
